module.exports = __webpack_public_path__ + "static/content-03-be92e8ff1fa7c2fe78eec0dbb7c31f6b.jpg";